var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"company-event-list-month"},[_c('div',{staticClass:"company-event-list-month-date"},[_c('div',[_vm._v(_vm._s(_vm.data.month))])])]),_vm._l((_vm.data.events),function(item,index){return _c('company-event-list-item',{key:index,attrs:{"data":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }